import ModalMsg from "../../../../../components/ModalMsg";
import React, {Fragment} from "react";
import NsDataTable from "../../../../../components/tabelle/NsDataTable";
import {getDataFormattata, getTimestampFormattato} from "../../../../../utility/common";

export default function TabellaCertDocumentiFirmatiView({
                                                            documentiFirmati,
                                                            totDocumentiFirmati,
                                                            showMsg,
                                                            setShowMsg,
                                                            modalMsg,
                                                            downloadDocFirmato,
                                                            inviaEmailDocumentoFirmatoCert,
                                                        }) {

    return (
        <Fragment>
            <ModalMsg
                show={showMsg}
                handleClose={() => setShowMsg(false)}
                testo={modalMsg}/>
            <NsDataTable
                data={documentiFirmati}
                totRighe={totDocumentiFirmati}
                columns={[
                    {
                        name: 'Numero Certificato',
                        selector: row => <Fragment>
                            {
                                row.nuovo_certificato &&
                                <i className="fas fa-people-arrows pe-1"/>
                            }
                            {row.numero_certificato}
                        </Fragment>,
                        sortable: true,
                    },
                    {
                        name: 'Socio',
                        selector: row => (row.nome || '') + ' ' + (row.cognome || ''),
                        sortable: true,
                    },
                    {
                        name: 'Tipo Certificato',
                        selector: row => row.tipo_certificato,
                        sortable: true,
                    },
                    {
                        name: 'Marca',
                        selector: row => row.marca,
                        sortable: true,
                    },
                    {
                        name: 'Modello',
                        selector: row => row.tipo,
                        sortable: true,
                    },
                    {
                        name: 'N° registrazione',
                        selector: row => (row.numero_registrazione + row.suffisso || '-'),
                        sortable: true,
                    },
                    {
                        name: 'Targa',
                        selector: row => row.targa,
                        sortable: true,
                    },
                    {
                        name: 'Data invio e-mail',
                        selector: row => getTimestampFormattato(row.data_invio_email_doc_firmato),
                        sortable: true,
                    },
                    {
                        name: '',
                        selector: row => <Fragment>
                            <div className="btn-group" role="group" aria-label="Button group with nested dropdown">
                                <div className="btn-group" role="group">
                                    <button id="btnGroupDrop1" type="button"
                                            className="btn btn-dark dropdown-toggle"
                                            data-bs-toggle="dropdown" aria-expanded="false">
                                        <i className="fa-solid fa-bars"></i>
                                    </button>
                                    <ul className="dropdown-menu" aria-labelledby="btnGroupDrop1">
                                        <li>
                                            <button
                                                className="dropdown-item"
                                                data-toggle="tooltip"
                                                title="Visualizza documento firmato"
                                                onClick={() => {
                                                    downloadDocFirmato(row, false);
                                                }}>
                                                <i className="fas fa-eye"/> Visualizza
                                            </button>
                                        </li>
                                        <li>
                                            <button
                                                className="dropdown-item"
                                                data-toggle="tooltip"
                                                title="Scarica documento firmato"
                                                onClick={() => {
                                                    downloadDocFirmato(row, true);
                                                }}>
                                                <i className="fas fa-download"/> Scarica
                                            </button>
                                        </li>
                                        <li>
                                            <button
                                                className="dropdown-item"
                                                data-toggle="tooltip"
                                                title="Invia e-mail a socio"
                                                onClick={() => {
                                                    inviaEmailDocumentoFirmatoCert(row.id_certificato);
                                                }}>
                                                <i className="fas fa-envelope"/> Invia e-mail a socio
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </Fragment>,
                        sortable: false,
                        right: true,
                    }
                ]}
                addPagination={false}
                addFiltri={false}
            >
            </NsDataTable>
        </Fragment>
    );

}